import { Component, ViewChild, ElementRef, ModuleWithProviders } from '@angular/core';
import { MatDialogRef, MatHorizontalStepper, MatSnackBar } from '@angular/material';
import { InformePersonalizadoService } from '../../../../providers/informe-personalizado.service';
import { FormControl, Validators } from '@angular/forms';
export enum StepperTitulos {
  CARGA_DE_DATOS = 0,
  SUBIR_ARCHIVOS = 1,
  ABM_ARCHIVOS = 2
}

@Component({
  selector: 'app-crear-informe-dialog',
  templateUrl: './crear-informe-dialog.component.html',
  styleUrls: ['./crear-informe-dialog.component.scss']
})
export class CrearInformeDialog {
  error: string = '';
  cargando: boolean = false;
  showTipoCliente:boolean=false;
  tablas_disponibles: any;
  tabla_seleccionada:any;
  titulo:string='';
  tabla = new FormControl('', [
    Validators.required,
    Validators.maxLength(500)
  ]);
  tipoCliente = new FormControl('');
  condicion:any='';
  condiciones_consulta:any='';
  consulta:any={};
  campos = new FormControl('');
  valor = new FormControl('');
  nombre = new FormControl('');
  campos_disponibles: any;
  campos_seleccionados:any[]=[];
  campo_condicion:any=null;
  valor_condicion:any='';
  condiciones:any=[
    {id:'=', value:'IGUAL'},
    {id:'<', value:'MENOR'},
    {id:'>', value:'MAYOR'},
    {id:'LIKE', value:'CONTIENE'},
    {id:'IN NULL', value:'ES VACIO'},
    {id: 'IS NOT NULL', value:'NO ES VACIO'}
  ]
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  @ViewChild('dialogContent') dialogContent: ElementRef;

  constructor(
    public dialogCrear: MatDialogRef<CrearInformeDialog>,
    public InformePersonalizadoService: InformePersonalizadoService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.cargando = true;
    // this.onTablaSelectedTipoCliente({ value: 'clientes' });
    this.InformePersonalizadoService.getTablas().subscribe(
      respuesta => {
        console.log('Estados', respuesta);
        if (respuesta.estado == 1) {
          this.tablas_disponibles = respuesta.tablas
          this.cargando = false;
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }

  onTablaSelected(event: any) {
    //Se agrega verificacion para mostrar el campo tipoCliente solo si la tabla seleccionada es entidad
    if(event.value == 'entidad'){
      this.showTipoCliente=true;
    }else{
      this.showTipoCliente=false;
    }
    //Se agrega verificacion para mostrar el campo tipoCliente solo si la tabla seleccionada es entidad
    this.InformePersonalizadoService.getCampos({ tabla: event.value }).subscribe(
      respuesta => {
       this.tabla_seleccionada=event.value;
        if (respuesta.estado == 1) {
          this.campos_disponibles = respuesta.campos
          this.cargando = false;
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }


  // onTablaSelectedTipoCliente(event: any) {
  //   this.campos_disponibles = [
  //     { id: 1, nombre: 'Prospectos' },
  //     { id: 2, nombre: 'Clientes' },
  //   ];
  //   this.cargando = false;
  // }

  onCampoSelected(event:any){
    this.campos_seleccionados=event.value;
  }
  onCampoCondicionSelected(event:any){
    this.campo_condicion=event.value;

  }
  onCondicionSelected(event:any){
    this.condicion=event.value;
  }
  onNombreSelected(valor){
      this.titulo=valor;
  }
  onValorSelected(valor){
    if(this.condicion == 'LIKE'){
      valor='%'+valor+'%';
    }
    valor="'"+valor+"'";

    this.valor_condicion=valor;
  }
  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  // finalizar carga del producto
  onFinalizar(): void {
    this.cargando=true;
    this.consulta.condiciones = [];
    this.consulta.tipoEntidad = this.tipoCliente.value;

    let condicion:any={}

    if(this.campo_condicion){
      if(!this.condicion){
        this.snackBar.open('Debe seleccionar al menos una condición', 'OK', { duration: 2750 });
        this.cargando=false;
        return
      }
      if(this.campo_condicion.includes("as")){
        this.campo_condicion = this.campo_condicion.split("as")[0];
      }
      condicion={campo_condicion:this.campo_condicion,condicion:this.condicion,valor:this.valor_condicion}
      this.consulta.condiciones.push(this.campo_condicion + ' ' +this.condicion + ' ' + this.valor_condicion);
    }

    let guardar_filtro={
      titulo:this.titulo,
      tabla:this.consulta['tabla'],
      campos:this.campos_seleccionados,
      // tipoCliente: this.tipoCliente.value,
      condiciones:[condicion]
    }


    this.InformePersonalizadoService.filtrarInforme({data : this.consulta}).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          this.cargando=false;
          this.guardar_filtro(guardar_filtro);
          this.dialogCrear.close(respuesta);
        }
      },
      error => {
        this.cargando = false;
      }
    );

  }

  guardar_filtro(filtro){
    this.InformePersonalizadoService.guardarFiltro({filtro : filtro}).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          this.cargando=false;
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }

  onCrear(): void {
    this.error = '';
    this.consulta.tabla=this.tabla_seleccionada;
    this.consulta.campos=this.campos_seleccionados;
    this.stepper.selected.completed = true;
    this.stepper.next();
  }

  setCargando(estado) {
    this.cargando = estado;
  }

  continuar(): void {
    this.stepper.selected.completed = true;
    this.stepper.next();
  }


  scrollToBottom() {
    this.dialogContent.nativeElement.scrollTop = this.dialogContent.nativeElement.scrollHeight;
  }


}
